import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

import {
  bomConfigVersionId,
  type BomConfigVersionId,
} from './BomConfigVersion.js'

/** Identifier type for public.bom_conduit_transition_ */
export type BomConduitTransitionId = string & {
  __brand: 'BomConduitTransitionId'
}

/** Represents the table public.bom_conduit_transition_ */
export default interface BomConduitTransitionTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<
    BomConduitTransitionId,
    BomConduitTransitionId | undefined,
    BomConduitTransitionId
  >

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  createdBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  updatedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  updatedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  deletedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  deletedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.uuid */
  versionId: ColumnType<
    BomConfigVersionId,
    BomConfigVersionId,
    BomConfigVersionId
  >

  /** Database type: pg_catalog.text */
  key: ColumnType<string, string, string>

  /** Database type: pg_catalog.text */
  itemCode: ColumnType<string, string, string>

  /** Database type: pg_catalog.bool */
  isActive: ColumnType<boolean | null, boolean | null, boolean | null>
}

export type BomConduitTransition = Selectable<BomConduitTransitionTable>

export type BomConduitTransitionInitializer =
  Insertable<BomConduitTransitionTable>

export type BomConduitTransitionMutator = Updateable<BomConduitTransitionTable>

export const bomConduitTransitionId =
  z.string() as unknown as z.Schema<BomConduitTransitionId>

export const bomConduitTransition = z.object({
  id: bomConduitTransitionId,
  createdAt: z.coerce.date().nullable().optional(),
  createdBy: z.string().nullable().optional(),
  updatedAt: z.coerce.date().nullable().optional(),
  updatedBy: z.string().nullable().optional(),
  deletedAt: z.coerce.date().nullable().optional(),
  deletedBy: z.string().nullable().optional(),
  versionId: bomConfigVersionId,
  key: z.string(),
  itemCode: z.string(),
  isActive: z.boolean().nullable().optional(),
}) as unknown as z.Schema<BomConduitTransition>

export const bomConduitTransitionInitializer = z.object({
  id: bomConduitTransitionId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  versionId: bomConfigVersionId,
  key: z.string(),
  itemCode: z.string(),
  isActive: z.boolean().optional().nullable(),
}) as unknown as z.Schema<BomConduitTransitionInitializer>

export const bomConduitTransitionMutator = z.object({
  id: bomConduitTransitionId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  versionId: bomConfigVersionId.optional(),
  key: z.string().optional(),
  itemCode: z.string().optional(),
  isActive: z.boolean().optional().nullable(),
}) as unknown as z.Schema<BomConduitTransitionMutator>
